import { useSortable } from "@dnd-kit/react/sortable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { getAmounts, intToDec } from "../../utils";
import { Quote } from "../../types";
import { Link } from "react-router-dom";

const Service = ({
  worker,
  index,
  installation,
  clientName,
  sellerName,
  onClick,
  sendTo,
  vertical = true,
}: {
  id?: string;
  worker?: string;
  index?: number;
  installation: Quote;
  clientName: string;
  sellerName: string;
  onClick: () => void;
  sendTo: (beginning: boolean) => () => void;
  vertical?: boolean;
}) => {
  const { ref, isDragging } = useSortable({
    id: installation.uuid,
    index: index!,
    type: "item",
    accept: "item",
    group: worker!,
  });

  const { finalSale, finalRent, fee } = getAmounts(installation);

  return (
    <div
      className="item border bg-white rounded-lg w-[230px] min-w-[230px] h-[125px] min-h-[125px] text-xs tracking-tight overflow-hidden"
      ref={ref}
      data-dragging={isDragging}
    >
      <div className="rounded-t-lg font-semibold border-b flex items-center">
        <div className="truncate p-2 flex-1">{clientName}</div>

        <div className="border-l p-2 bg-gray-100 text-gray-600">
          {installation.number}
        </div>
      </div>

      <div className="px-2 py-1 text-gray-600 flex flex-col gap-0.5 text-xs">
        <div className="flex items-center">
          <div className="flex items-center gap-1.5 flex-1">
            <FontAwesomeIcon icon="check-circle" className="text-gray-500" />
            {moment(installation.authorizationDate).format("DD/MM/YY hh:mm")}
          </div>

          {installation.notes.length > 0 && (
            <div className="flex items-center gap-1 font-semibold bg-gray-100 text-gray-500 px-1 rounded">
              <FontAwesomeIcon icon="comment" className="text-gray-400" />
              {installation.notes.length}
            </div>
          )}
        </div>

        <div className="flex items-center gap-1.5">
          <FontAwesomeIcon icon="user" className="text-gray-500" />
          {sellerName}
        </div>
      </div>

      <div className="px-2 flex gap-2 pb-1 h-6">
        {finalSale > 0 && (
          <div className="bg-cyan-100 text-cyan-800 rounded text-xs px-1.5 py-0.5 tracking-tighter">
            {intToDec(finalSale)}
          </div>
        )}

        {finalRent > 0 && (
          <div className="bg-lime-100 text-lime-800 rounded text-xs px-1.5 py-0.5 tracking-tighter">
            {intToDec(finalRent)}
          </div>
        )}

        {fee > 0 && (
          <div className="bg-violet-100 text-violet-800 rounded text-xs px-1.5 py-0.5 tracking-tighter">
            {intToDec(fee)}
          </div>
        )}
      </div>

      <div className="border-t flex items-center">
        <Link
          className="font-semibold tracking-tight hover:bg-slate-50 py-1 px-2 border-r"
          to={`/externo/proposta/${installation.externalHash}`}
          target="_blank"
        >
          Abrir
        </Link>

        <button
          className="font-semibold tracking-tight hover:bg-slate-50 py-1 px-2 border-r"
          onClick={onClick}
        >
          Detalhes
        </button>

        <div className="flex-1" />

        <button
          className="font-semibold tracking-tight hover:bg-slate-50 py-1.5 px-2 border-l"
          onClick={sendTo(true)}
        >
          <FontAwesomeIcon
            className="hidden md:block"
            icon={vertical ? "arrow-up" : "arrow-left"}
          />
          <FontAwesomeIcon icon="arrow-left" className="md:hidden" />
        </button>

        <button
          className="font-semibold tracking-tight hover:bg-slate-50 py-1.5 px-2 border-l"
          onClick={sendTo(false)}
        >
          <FontAwesomeIcon
            className="hidden md:block"
            icon={vertical ? "arrow-down" : "arrow-right"}
          />
          <FontAwesomeIcon icon="arrow-right" className="md:hidden" />
        </button>
      </div>
    </div>
  );
};

export default Service;
